export default __webpack_public_path__ + "static/ai-solutions-with-roadmap4--mobile-c414383e8eb1122140c81dde269f0c21.webp";